import { useCallback, useEffect, useState } from 'react';
import CourseAPI from '../../course/CourseAPI';
import { CertificateLanguage } from '../../certificate/types/Certificate';
import { DisplayedCourseInstance } from '../types/CourseInstance';

export function useCertificateLanguages(
  courseInstance: DisplayedCourseInstance,
) {
  const [loadingCertificateLanguages, setLoadingCertificateLanguages] =
    useState(false);
  const [certificateLanguages, setCertificateLanguages] = useState<
    CertificateLanguage[]
  >([]);

  const fetchLanguages = useCallback(async () => {
    setLoadingCertificateLanguages(true);
    try {
      const response = await CourseAPI.getCourseCertificateLanguages(
        courseInstance.course.id,
      );
      setCertificateLanguages(response.data);
    } finally {
      setLoadingCertificateLanguages(false);
    }
  }, [courseInstance.course.id]);

  useEffect(() => {
    fetchLanguages();
  }, [fetchLanguages]);

  return { certificateLanguages, loadingCertificateLanguages };
}
